import { motion } from "framer-motion";

const Contact = () => {
  return (
    <section className="min-h-screen bg-white py-20">
      <div className="max-w-6xl mx-auto px-4">
        
        {/* Header */}  
        <div className="text-center max-w-3xl mx-auto">
          <h1 className="text-4xl lg:text-5xl font-bold text-[#256ab7]">
            Contact Us
          </h1>
          <p className="text-gray-500 mt-4 leading-7">
            Get in touch with Coolwell Coils for high-quality HVAC coil solutions.
            We are ready to assist you with your project requirements.
          </p>
        </div>

        {/* Content */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 mt-14">
          
          {/* Contact Info */}
          <motion.div
            initial={{ opacity: 0, x: -40 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
            className="bg-slate-50 p-8 rounded-3xl shadow-sm"
          >
            <h2 className="text-2xl font-semibold text-gray-900">
              Get In Touch
            </h2>

            <p className="text-gray-500 mt-4 leading-7">
              Feel free to contact us anytime. Our team will respond as soon as possible.
            </p>

            <div className="mt-8 space-y-5 text-gray-700">
              <p><span className="font-semibold">📍 Address:</span> Pakistan</p>
              <p><span className="font-semibold">📞 Phone:</span> +92 300 0000000</p>
              <p><span className="font-semibold">📧 Email:</span> info@coolwellcoils.com</p>
              <p><span className="font-semibold">⏰ Hours:</span> Mon - Sat (9:00 AM - 6:00 PM)</p>
            </div>
          </motion.div>

          {/* Contact Form */}
          <motion.div
            initial={{ opacity: 0, x: 40 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
            className="bg-white border border-gray-100 p-8 rounded-3xl shadow-sm"
          >
            <h2 className="text-2xl font-semibold text-gray-900">
              Send Message
            </h2>

            <form className="mt-6 space-y-5">
              
              <input
                type="text"
                placeholder="Your Name"
                className="w-full px-4 py-3 border rounded-xl focus:outline-none focus:ring-2 focus:ring-black"
              />

              <input
                type="email"
                placeholder="Your Email"
                className="w-full px-4 py-3 border rounded-xl focus:outline-none focus:ring-2 focus:ring-black"
              />

              <input
                type="text"
                placeholder="Subject"
                className="w-full px-4 py-3 border rounded-xl focus:outline-none focus:ring-2 focus:ring-black"
              />

              <textarea
                rows="5"
                placeholder="Your Message"
                className="w-full px-4 py-3 border rounded-xl focus:outline-none focus:ring-2 focus:ring-black"
              ></textarea>

              <button
                type="submit"
                className="w-full py-3 bg-black text-white rounded-xl font-semibold hover:opacity-90 transition"
              >
                Send Message
              </button>
            </form>
          </motion.div>

        </div>
      </div>
    </section>
  );
};

export default Contact;